module.exports = __webpack_public_path__ + "img/p-one-step-05.85080dfa.png";